import adultexam from "./adultexam";
import basic from "./basic";
import education from "./education";
import examination from "./examination";
import server from "./server";
import siteplatform from "./siteplatform";
import study from "./study";
import textbook from "./textbook";
import thesis from "./thesis";

/**
 * 华博特项目接口文档
 */
export default {
  adultexam,
  basic,
  education,
  examination,
  server,
  siteplatform,
  study,
  textbook,
  thesis,
};
